<template>
  <transition name="slideup">
    <div class="modal" :id="id" v-if="isDisplayed">
      <div class="modal-backdrop" @click.prevent="onBack"></div>
      <div class="modal-container">
          <div class="modal-head">
              <button @click.prevent="onBack" class="modal-backlink">
                <sprite
                  :type="'arrow-left'"
                  :width="19"
                  :height="12"
                />
                <span class="u-visually-hidden">{{ $t('back.modal') }}</span>
              </button>
              <h3 class="modal-title">{{ title }}</h3>
          </div>
          <div class="modal-content">
            <slot></slot>
          </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Sprite from '@/components/components/Sprite.vue';

export default {
  components: {
    Sprite
  },
  props: {
    isDisplayed: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    id: {
      type: String
    }
  },
  methods: {
    onBack() {
      this.$emit('closeModal');
    }
  }
};
</script>

<style lang="scss">
.modal {
    @include position(fixed, 0 0 0 0);
    z-index: 999;

    &-backdrop {
       @include position(fixed, 0 0 0 0);
    }

    &-container {
      @include position(absolute, null 0 0 0);
      @include margin(0 auto);
      max-width: 640px;
      height: calc(100% - 65px);
      background-color: $white;
      border-radius: 30px 30px 0 0;

      #modal-share & {
        height: 100%;
        border-radius: 0;
      }

      #modal-leaderboard &,
      #modal-terms & {
        max-height: 675px;
      }

      #modal-signup &,
      #modal-login & {
        @media (min-height: 500px) {
          height: auto;
          max-height: calc(100% - 70px);
        }
      }
      #modal-login-form &,
      #modal-lost-password &,
      #modal-rules & {
        @media (min-height: 440px) {
          height: auto;
          max-height: calc(100% - 70px);
        }
      }

      #modal-quiz & {
        @media (min-height: 580px) {
          height: auto;
          max-height: calc(100% - 50px);
        }
      }

      #modal-signup-form & {
        @media (min-height: 780px) {
          height: auto;
          max-height: calc(100% - 70px);
        }
      }
    }

    &-head {
      @include padding(10px 20px null);
    }

    &-title {
      @include font('secondary', 'regular');
      @include margin(null null 25px null);
      color: $primary;
      font-size: rem(15px);
      line-height: 1.333;
      text-align: center;
      text-transform: uppercase;

      #modal-leaderboard & {
        @include margin(null null 44px null);
      }
    }

    &-backlink {
      @include padding(15px 20px 15px 0);
      .svg {
        fill: $secondary;
      }
    }

    &-content {
      @include padding(null 20px 50px);
      overflow-y: auto;
      color: $primary;
      max-height: calc(100% - 99px);
      .btn {
        width: 100%;
      }
      #modal-leaderboard & {
        max-height: calc(100% - 108px);
      }
    }
}

.slideup-enter-active, .slideup-leave-active {
  transition: transform .5s;
}
.slideup-enter, .slideup-leave-to {
  transform: translateY(100%);
}
</style>
